import React from 'react';
import PropTypes from 'prop-types';
import { LineItem } from 'common/display/LineItem';

const AuthorizationHistoryLineItem = ({
  field,
  children,
  ...rest
}) => (
  <LineItem
    field={field}
    valueClassName="col-span-3 ml-2 text-sm"
    {...rest}
  >
    {children}
  </LineItem>
);

AuthorizationHistoryLineItem.propTypes = {
  field: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default AuthorizationHistoryLineItem;
